// IUSA Registration Thank You Page - https://www.infousa.com/resources/register/thank-you/
if (WordPressPageID == '6832') {

	window.setTimeout(function() {
	
		if (iusaEnvironment == 'DEV') {
	
			location.href = 'https://dev-core.dataaxleusa.com/MyAccount/';
	
		} else if (iusaEnvironment == 'TEST') {
	
			location.href = 'https://test-core.dataaxleusa.com/MyAccount/';
	
		} else if (iusaEnvironment == 'PROD') {
	
			location.href = 'https://core.dataaxleusa.com/MyAccount/';
	
		} else {

			return false;

		}
	
	}, 5000);

}